import fly from 'flyio'
import qs from 'qs'
import { Message, Loading } from 'element-ui'
// import store from '@/store'
import router from '@/router'

// 创建axios实例
// console.log('baseURL', process.env.VUE_APP_BASE_API)

fly.config.timeout = 10 * 1000
// fly.config.baseURL = process.env.VUE_APP_BASE_API + 'oxyadmin/'
fly.config.baseURL = process.env.VUE_APP_BASE_API
fly.config.withCredentials = true
fly.config.headers = {
  'content-type': 'application/x-www-form-urlencoded'
}

// 请求拦截
fly.interceptors.request.use(
  config => {
    fly.loading = Loading.service({ fullscreen: true, background: 'rgba(0,0,0,.1)', text: 'Loading' })
    if (config['headers']['Content-Type'] !== 'application/x-www-form-urlencoded') { return config}
    config.body = qs.stringify(config.body)
    return config
  },
  error => {
    fly.loading.close()
    return Promise.reject(error)
  }
)

// 响应拦截
fly.interceptors.response.use(
  response => {
    const res = JSON.parse(response.data)
    // console.log('+++')
    fly.loading.close()
    if (res.status === 410) {
      // 重新登录
      router.push('/login')
    } else if (res.status === 200) {
      return res
    } else {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })

      return Promise.reject(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    fly.loading.close()
    return Promise.reject(error)
  }
)

export default fly
